import { call, put, takeEvery, takeLatest, retry } from "redux-saga/effects";
import * as actionTypes from "../consts/actionTypes";
import * as API from "../api";

function* asyncFetchZoneFilters({ payload }) {
  try {
    const response = yield call(API.getFilterCartilla, payload);
    yield put({ type: actionTypes.SUCCESS_GET_FILTERS_VALUES, response, message: '' });
  } catch (error) {
    yield put({
      type: actionTypes.FAILURE_GET_FILTERS_VALUES,
      message: error.message,
    });
  }
}

function* asyncGetLocalidadesBarrios({ payload }) {
  try {
    const response = yield call(API.getLocalidadesBarrio, payload);
    if (response)
      yield put({
        type: actionTypes.SUCCESS_GET_LOCALIDADES_BARRIOS,
        response,
        message: ''
      });
  } catch (error) {
    yield put({
      type: actionTypes.FAILURE_GET_LOCALIDADES_BARRIOS,
      message: error.message,
    });
  }
}

function* asyncGetEspecialidadesEstudios({ payload }) {
  try {
    const response = yield call(
      API.getEspecialidadesEstudiosComplementarios,
      payload
    );
    if (response)
      yield put({
        type: actionTypes.SUCCESS_GET_ESPECIALIDADES_ESTUDIOS_COMPLEMENTARIOS,
        response,
        message: ''
      });
  } catch (error) {
    yield put({
      type: actionTypes.FAILURE_GET_ESPECIALIDADES_ESTUDIOS_COMPLEMENTARIOS,
      message: error.message,
    });
  }
}

function* asyncGetPrestadoresCartilla({ payload }) {
  try {
    const response = yield retry(3, 1000, API.getPrestadoresResult, payload);
    if (response)
      yield put({
        type: actionTypes.SUCCESS_GET_PRESTADORES_RESULT,
        response
      });
  } catch (error) {
    const message = error?.response?.data?.errors?.[0] || error?.message || "En este momento no es posible crear la solicitud. Por favor, intente nuevamente.";
    yield put({
      type: actionTypes.FAILURE_GET_PRESTADORES_RESULT,
      message,
    });
  }
}

function* asyncGetCompleteProfile({ payload }) {
  try {
    const response = yield call(API.getCompleteProfile, payload);
    if (response)
      yield put({
        type: actionTypes.SUCCESS_GET_PERFIL_COMPLETO,
        response,
        message: ''
      });
  } catch (error) {
    yield put({
      type: actionTypes.FAILURE_GET_PERFIL_COMPLETO,
      message: error.message,
    });
  }
}

function* asyncGetAllCartillasUrl({ payload }) {
    try {
        const response = yield call(API.getCartillasUrlApi, payload);
        if (response) {
            yield put({ type: actionTypes.SUCCESS_GET_ALL_CARTILLAS_URL, response });
        }
    } catch (error) {
        yield put({ type: actionTypes.SEND_REQUEST_FAILURE, message: error });
    }
}
 
function* asyncGetCartillaUrl({ payload }) {
    try {
        const response = yield call(API.getCartillaUrlApi, payload);
        if (response) {
            yield put({ type: actionTypes.SUCCESS_GET_CARTILLA_URL, response });
        }
    } catch (error) {
        yield put({ type: actionTypes.SEND_REQUEST_FAILURE, message: error });
    }
}

// Watchers
export default function* filtersSaga() {
  yield takeEvery(actionTypes.GET_FILTERS_VALUES, asyncFetchZoneFilters);
  yield takeLatest(
    actionTypes.GET_LOCALIDADES_BARRIOS,
    asyncGetLocalidadesBarrios
  );
  yield takeLatest(
    actionTypes.GET_ESPECIALIDADES_ESTUDIOS_COMPLEMENTARIOS,
    asyncGetEspecialidadesEstudios
  );
  yield takeLatest(
    actionTypes.GET_PRESTADORES_CARTILLA,
    asyncGetPrestadoresCartilla
  );
  yield takeLatest(actionTypes.GET_PERFIL_COMPLETO, asyncGetCompleteProfile);
  yield takeLatest(actionTypes.GET_ALL_CARTILLAS_URL, asyncGetAllCartillasUrl);
  yield takeLatest(actionTypes.GET_CARTILLA_URL, asyncGetCartillaUrl);
}
